import React, {useContext, useEffect, useState} from 'react';
import ModalContainer from "../../common/modal_container";
import girl_2 from "../../../_asset/source/girl_2.png";
import {exportNewSlotJson, SlotImageInterface} from "../../../data/gameData_slot";
import {ShadowLight} from "./casino_popup";
import {FloatLayout} from "../pop_component/float_layout";
import {loadingContext} from "../../provider/game_loading_provider";

import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, EffectCoverflow, Navigation, Pagination} from "swiper";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import AudioPlayer from "../../layout/audio_player";
import MediaPlayer from "../../layout/media_player";
import {lobbyModalContext} from "../../provider/lobby_modal_provider";
import swal from "sweetalert";
import { Logo_1, Logo_2 } from '../../common/logo';

function SlotPopup({title}: {title: string}) {
    const [popShow, setPopShow] = useState<boolean>(false)

    return (
        <>
            <p className={"--pointer"} onClick={e=>setPopShow(true)}>{title}</p>
            <SlotModal popShow={popShow}
                       setPopShow={setPopShow}
                       title={title}/>
        </>
    );
}

export default SlotPopup;

export function SlotModal({popShow, setPopShow, title}: {popShow: boolean; setPopShow: Function; title: string}){
    return (
        <ModalContainer show={popShow}
                        setShow={setPopShow}
                        closeBtn={true}
            // title={title}
                        className={"casino-pop"}
        >
            {/*슬롯*/}
            <SlotNewPopup/>
        </ModalContainer>
    )
}

function SlotNewPopup() {
    const [state, setState] = useState<boolean>(false)
    const [focusTitle, setFocusTitle] = useState<string>('')
    const [oneFocus, setOneFocus] = useState(false)
    const [deviceWidth, setDeviceWidth] = useState<number>(window.innerWidth)
    const [perViewSize, setPerViewSize] = useState<number>(7)

    const roundList = exportNewSlotJson.slice(0, 8);
    const floatList = exportNewSlotJson.slice(9);

    window.onresize = function(){
        setDeviceWidth(window.innerWidth)
    }
    useEffect(() => {
        setTimeout(() => {
            setState(true)
        }, 200)
    }, [])
    useEffect(()=> {
        if(deviceWidth > 1200){
            setPerViewSize(7)
        }else if(deviceWidth > 992){
            setPerViewSize(6)
        }else if(deviceWidth > 768){
            setPerViewSize(4)
        }else if(deviceWidth > 576){
            setPerViewSize(3)
        }else{
            setPerViewSize(2)
        }
        // console.log(perViewSize)
    }, [deviceWidth])
    return (
        <>
            <div className={'game-pop-layout'}>
                <div className='casino-header'>
                    <Logo_1 />
                </div>
                <FloatLayout girl={girl_2} />
                {
                    state ?
                        <div className={"casino-list slot"}>
                            <div className={`focus-title`}>
                                {
                                    focusTitle
                                        ? <div className={'hover-logo-action'}>
                                                <img src={focusTitle} alt="asd"/>
                                            {/* <div className={'company-logo'}>
                                                <img src={focusTitle} alt="asd"/>
                                            </div> */}
                                        </div>
                                        : <div className={'default'}>
                                            <Logo_2 />
                                        </div>
                                }
                            </div>
                            <div className={`company-list slot`}
                                 onMouseOut={e => setOneFocus(false)}>
                                {
                                    roundList?.map((slot, index) => {
                                        return (
                                            <SlotNewPopupItem key={index}
                                                              slot={slot}
                                                              setOneFocus={setOneFocus}
                                                              isOneFocus={oneFocus}
                                                              setFocusTitle={setFocusTitle}
                                            />
                                        )
                                    })
                                }
                            </div>
                        </div>
                        : <></>
                }
            </div>
            {
                state ?
                    <div className={'slot-float-list-layout'}
                         onMouseOut={e => setOneFocus(false)}>
                        <Swiper
                            slidesPerView={perViewSize}
                            loop={true}
                            navigation={{
                                enabled: true,
                                nextEl: ".swiper-arrow-next",
                                prevEl: ".swiper-arrow-prev",
                            }}
                            modules={[Navigation]}
                        >
                            {
                                floatList.map((slot,index)=> (
                                    <SwiperSlide key={index}>
                                        <SlotNewPopupItem slot={slot}
                                                          setOneFocus={setOneFocus}
                                                          isOneFocus={oneFocus}
                                                          setFocusTitle={setFocusTitle}
                                                          isBottom
                                        />
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                        <div className={'swiper-arrow-next'}>
                            <div className={'arrow'}></div>
                            {/*<FontAwesomeIcon icon={faArrowRight} />*/}
                        </div>
                        <div className={'swiper-arrow-prev'}>
                            <div className={'arrow'}></div>
                            {/*<FontAwesomeIcon icon={faArrowLeft} />*/}
                        </div>
                    </div>
                    : <></>
            }
        </>
    )
}

type gameItemsClassType = "" | "disabled" | "focus"
function SlotNewPopupItem({slot, setFocusTitle, setOneFocus, isOneFocus, isBottom}:
                              {slot: SlotImageInterface,
                                  setFocusTitle: Function,
                                  setOneFocus: Function,
                                  isOneFocus: boolean,
                                  isBottom: boolean}){
    const [focus, setFocus] = useState<boolean>(false)
    const [state, setState] = useState<gameItemsClassType>("")

    const {SetLoadingPop} = useContext(loadingContext)
    const [audioPlay, setAudioPlay] = useState<boolean>(false)
    const {SetLobbyShow, SetVendor, SetType} = useContext(lobbyModalContext)

    useEffect(() => {
        if (isOneFocus && focus) {
            // mouseover
            setState('focus')
        } else if (isOneFocus && !focus) {
            // other items
            setState('disabled')
        } else {
            setState('')
        }
    }, [focus, isOneFocus])
    return (
        <div onClick={e=> {
            if(slot.vendor == 'Booongo'){
                window.open(`/gameLobby/Booongo/?uid=bng_mini_lobby&vendor=Booongo`,
                // window.open(`https://slot-cu88.com/gameLobby/Booongo/?uid=bng_mini_lobby&vendor=Booongo`,
                    `${slot.vendor}_${slot.id}`, `width=1200 height=640`)
            }else
            if(['popok', 'micro-gaming'].includes(slot.vendor)){
                swal({
                    text: '점검중 입니다.',
                    icon: 'warning'
                })
            }else{
                SetVendor(slot.vendor)
                SetType('slot')
                SetLobbyShow()
            }
             // ErrorVendorCheck(slot.vendor, slot.id, 'slot')
             //    .finally(()=> SetLoadingPop(false))
             }}
             onMouseOver={e=> {
                 setAudioPlay(true)
                 setFocusTitle(slot.logo)
                 setFocus(true)
                 setOneFocus(true)
             }}
             onMouseOut={e=> {
                 setAudioPlay(false)
                 setFocusTitle('')
                 setFocus(false)
             }}
             className={`company slot ${state}`} title={slot.name}>
            <div className={'inner-border'}></div>
            {
                slot.hover
                    ? <div className={'video-player'}>
                        <img src={slot.hover} className={''} alt=""/>
                        {/*<MediaPlayer src={slot.hover} loop />*/}
                        <div className={'gif-cover'}>
                            <img src={slot.logo} className={'logo'} alt={'logo'} title={slot.name}  />
                        </div>
                    </div>
                    :
                    <div className={'inner-image'}>
                        <img src={slot.img}     className={'image'} alt=""/>
                    </div>
            }
            <AudioPlayer type={"company"} play={audioPlay}/>
            <ShadowLight/>
        </div>
    )
}
SlotNewPopupItem.defaultProps = {
    isBottom: false
}